<template>
    <q-page padding>
        <filter-mobile @showFiles="showFiles" @changeFilter="changeFilter"/>

        <q-tabs v-model="tab" color="white" text-color="primary" underline-color="primary" class="shadow-1 bg-white q-mt-md" align="justify" v-if="show_files">
            <q-tab slot="title" name="library" :label="$t(title_library)" icon="fal fa-books" />

            <q-tab-pane name="library" class="q-px-md q-pb-xl q-mt-md">
                <div class="row gutter-sm">
                    <div class="col-12">
                        <div class="row gutter-md">
                            <div class="col-12">
                                <q-infinite-scroll :handler="loadLibraries" :offset="10" ref="library_scroll">
                                    <div class="row gutter-md">
                                        <div class="col-xs-12 col-sm-4" v-for="(library, index) in libraries" :key="index">
                                            <card-library :library="library" :key="library.id" @cardClicked="showModal" @changeHits="changeHits" />
                                        </div>
                                    </div>

                                    <div class="text-center q-mt-xl">
                                        <q-spinner-dots slot="message" :size="40" v-if="has_next_page"></q-spinner-dots>
                                    </div>
                                </q-infinite-scroll>
                            </div>
                        </div>
                    </div>
                </div>

                <modal-library :library="library" :show="show_modal" @hideModal="hideModal" @changeHits="changeHits" />
            </q-tab-pane>
        </q-tabs>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import Card from 'components/library/Card'
import Modal from 'components/library/Modal'
import FilterMobile from 'components/library/FilterMobile'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "library"] },

    data() {
        return {
            tab: 'library',
            libraries: [],
            show_modal: false,
            library: [],
            id_file: '',
            page: 1,
            has_next_page: true,
            show_files: false
        }
    },

    components: {
        'card-library': Card,
        'modal-library': Modal,
        'filter-mobile': FilterMobile,
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            search: 'libraries/search',
            selected_areas: 'libraries/selected_areas',
            selected_groups: 'libraries/selected_groups',
            selected_categories: 'libraries/selected_categories',
            selected_tags: 'libraries/selected_tags',
            selected_extensions: 'libraries/selected_extensions',
            reload_content: 'common/reload_content',
            clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        title_library(){
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
				if (obj) {
					return obj.title_library == '' ? 'library' : obj.title_library
				}
			}
		},
    },

    methods: {
        fetchLists() {
            this.$q.loading.show()

            this.$axios.get('/accounts/get_site_registration_lists/', this.getHeader)
            .then(response => {
                this.$store.dispatch('site_lists/SET_LISTS', [response.data])
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        loadLibraries(index, done) {
            if (this.has_next_page) {
                let data = {
                    "page_size": 9,
                    "page": this.page,
                    "search": this.search,
                    "tags": this.selected_tags,
                    "extension": this.selected_extensions
                }

                if (this.selected_areas != 'all' && this.selected_areas != '') data.areas = this.selected_areas
                if (this.selected_groups != 'all' && this.selected_groups != '') data.user_groups = this.selected_groups
                if (this.selected_categories != 'all'  && this.selected_categories != '') data.category = this.selected_categories

                this.$axios.get('/etraining_library_files/files/?' + this.$qs.stringify(data, { arrayFormat: 'repeat' }), this.getHeader)
                .then(response => {
                    response.data.results.map((library) => {
                        let image_small = ''
                        let image_medium = ''
                        let image_thumb = ''
                        let image_original = ''

                        let obj = library.image_urls.find((obj) => { return obj.name === 'thumbnail' })
                        if (obj) image_thumb = obj.image_url

                        obj = library.image_urls.find((obj) => { return obj.name === 'small' })
                        if (obj) image_small = obj.image_url

                        obj = library.image_urls.find((obj) => { return obj.name === 'medium' })
                        if (obj) image_medium = obj.image_url

                        obj = library.image_urls.find((obj) => { return obj.name === 'original' })
                        if (obj) image_original = obj.image_url

                        this.libraries.push({
                            id: library.id,
                            title: library.title,
                            description: library.description,
                            category: library.category,
                            file_url_complete: library.file_url_complete,
                            file_url_download: library.file_url_download,
                            extension: library.extension,
                            size: library.size,
                            hits: library.hits ? library.hits : "0",
                            image_thumb: image_thumb,
                            image_small: image_small,
                            image_medium: image_medium,
                            image_original: image_original,
                            file_preview: library.file_preview,
                            tags: library.tags,
                            allow_download: library.allow_download
                        })
                    })

                    if (!response.data.next) this.has_next_page = false
                    else this.page++
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    done()
                })
            }
        },

        changeFilter() {
            this.has_next_page = true
            this.libraries = []
            this.page = 1

            if (this.$refs.library_scroll) {
                this.$refs.library_scroll.stop()
                this.$refs.library_scroll.resume()
                this.$refs.library_scroll.loadMore()
            }
        },

        showModal(id) {
            this.$q.loading.show()
            this.$axios.get(`/etraining_library_files/files/${id}/`, this.getHeader)
            .then(response => {
               this.library = response.data
               this.hitView()
            })
            .catch(e => {
                this.$q.notify({
                    message: this.$t('library_file_not_found'),
                    type: 'negative',
                    icon: 'fal fa-ban'
                })
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        changeHits(id) {
            let obj = this.libraries.find((obj) => { return obj.id === id })
            if (obj) obj.hits++
        },

        hideModal() {
            this.show_modal = false
        },

        showFiles(show) {
            this.show_files = show
        },

        hitView() {
            this.$axios.get(`/etraining_library_files/files/${this.library.id}/request_view_file/`, this.getHeader)
            .then(response => {
                this.show_modal = true
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        }
    },

    watch: {
        reload_content: function() {
            this.fetchLists()
        }
    },

    created() {
        if(this.$route.params.name) {
            this.$store.dispatch('libraries/SET_FILTERS_SEARCH', [this.$route.params.name])
            this.show_files = true
        }
        if (this.$route.params.id_file) this.id_file = this.$route.params.id_file
        this.fetchLists()
    },

    mounted() {
        if (this.$q.platform.is.cordova && this.$q.platform.is.android) {
            let storage_location = 'file:///storage/emulated/0/'
            let folder = 'Downloads/' + process.env.PROJECT_FOLDER + '/'

            downloader.init({folder: folder, fileSystem: storage_location, noMedia: false})
        }
    },

    watch: {
        $route: function (to, from) {
            if(this.$route.params.name) {
               this.$store.dispatch('libraries/SET_FILTERS_SEARCH', [this.$route.params.name])
               this.changeFilter()
               this.show_files = true
            }
        },

    },
}
</script>

<style>

</style>
